"use client";
import axios from "axios";
import { useEffect, useState } from "react";
import { errorNotification } from "@/utils/functions";
import { messages } from "@/constants/messages";
const useAsync = <T extends any>(asyncFunction: any, refresher?: any) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(true);

  const execute = async (cancelToken?: any) => {
    try {
      setLoading(true);
      const res = await asyncFunction({ cancelToken });
      setData(res.data.data);
      setError("");
    } catch (err: any) {
      setError(err.message);
      setData(null);
      if (axios.isCancel(err)) {
        errorNotification(messages.ERROR_NETWORK);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let unmounted = false;
    const source = axios.CancelToken.source();

    if (!unmounted) {
      execute(source.token);
    }

    return () => {
      unmounted = true;
      source.cancel("error canceled");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(refresher)]);

  const refresh = () => {
    const source = axios.CancelToken.source();
    execute(source.token);
  };

  return {
    data,
    error,
    loading,
    refresh, // 👈 On expose la fonction ici
  };
};

export default useAsync;
